import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const Wrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid ${colors.shade30};

  gap: 16px;
  padding: 24px;

  width: 100%;

  ${media.sm`

  `}
`;
